export default "__VITE_ASSET__huV3EyP8__"